import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from 'react';
import {
  Modal,
  Form,
  Input,
  Button,
  Select,
  Tabs,
  Row,
  Col,
  Radio,
} from 'antd';
import IntlMessages from '../../components/IntlMessage';
import { useIntl } from 'react-intl';
import usersApi from '../../api/users';
import CountryData from '../../utils/countrydata';
import operatorsApi from '../../api/operators';
import { useMounted } from '../../hooks/useMounted';

const { TabPane } = Tabs;
const { Option } = Select;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

export default function UsersForm(props) {
  const { isMounted } = useMounted();
  const { onClose, currentData, open, isAdmin } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const place_pass = 'input password';
  const [operatorOption, setOperatorOption] = useState([]);
  const [userOperator, setUserOperator] = useState(null);
  //console.log("?",loading)
  const intl = useIntl();

  console.log('currentData: ', currentData, userOperator, operatorOption);
  useEffect(() => {
    async function fetch() {
      if (isMounted.current) {
        const filter = {
          limit: 9999,
          page: 1,
          order_by: 'title',
          order_dir: 'ASC',
        };

        const operatorRes = await operatorsApi.getAll(filter);
        const list_operator = operatorRes.data.map((item) => {
          return {
            label: item?.title,
            value: item?.id,
          };
        });
        setOperatorOption(list_operator);

        const destinationRes = await operatorsApi.getUserOperator(
          currentData?.id
        );
        const destinationData = destinationRes;

        if (destinationData) {
          form.setFieldsValue({ operator_id: destinationData?.operator?.id });
        }
        setUserOperator(destinationData);
      }
    }
    currentData &&
      ['operator_user', 'collaborator'].some((role) =>
        currentData.roles.includes(role)
      ) &&
      fetch();
  }, [currentData, isMounted]);

  const rolesTypes = {
    Super: 'super',
    Admin: 'admin',
    Collaborator: 'collaborator',
    OperatorAdmin: 'operator',
    OperatorUser: 'operator_user',
    Driver: 'driver',
    Store: 'store',
    Customer: 'customer',
    Agent: 'agent',
  };

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        if (isAdmin) {
          data.roles = 'admin';
        }
        if (currentData) {
          usersApi
            .update(currentData.id, data)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });

          if (
            data.operator_id &&
            data.operator_id !== userOperator?.operator?.id
          ) {
            let operator_data = {
              operator_id: data.operator_id,
            };
            operatorsApi
              .updateUserOperatorByUser(currentData.id, operator_data)
              .then(() => {
                console.log('Operator updated');
              })
              .catch((error) => {
                console.error(error);
                Modal.error({
                  title: error.data.message,
                  okText: intl.formatMessage({ id: 'global.close' }),
                });
              });
          }
        } else {
          usersApi
            .create(data)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleCancel = () => {
    //form.resetFields();
    onClose();
  };

  let initialValue = {
    firstname:
      currentData && currentData.firstname ? currentData.firstname : '',
    lastname: currentData && currentData.lastname ? currentData.lastname : '',
    email: currentData && currentData.email ? currentData.email : '',
    roles: currentData && currentData.roles ? currentData.roles : '',
    mobile: currentData && currentData.mobile ? currentData.mobile : '',
    username: currentData && currentData.username ? currentData.username : '',
    is_verified: currentData && currentData.is_verified ? 1 : 0,
    is_mobile_verified: currentData && currentData.is_mobile_verified ? 1 : 0,
    status: currentData && currentData.status ? 1 : 0,
    phone_code:
      currentData && currentData.phone_code ? currentData.phone_code : '+221',
  };

  return (
    <Modal
      title={
        currentData ? (
          <IntlMessages id="global.edit" />
        ) : (
          <IntlMessages id="global.add" />
        )
      }
      visible={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="60%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessages id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}>
          {<IntlMessages id="global.save" />}
        </Button>,
      ]}>
      <Form
        {...layout}
        form={form}
        initialValues={initialValue}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}>
        <Tabs defaultActiveKey="1">
          <TabPane tab={<IntlMessages id="global.users" />} key="1">
            <Form.Item
              label={<IntlMessages id="global.firstname" />}
              name="firstname"
              rules={[
                {
                  required: true,
                  message: <IntlMessages id="global.requiredfield" />,
                },
              ]}>
              <Input />
            </Form.Item>

            <Form.Item
              label={<IntlMessages id="global.lastname" />}
              name="lastname"
              rules={[
                {
                  required: true,
                  message: <IntlMessages id="global.requiredfield" />,
                },
              ]}>
              <Input />
            </Form.Item>
            {!isAdmin && (
              <Form.Item
                label={<IntlMessages id="global.roles" />}
                name="roles"
                rules={[
                  {
                    required: true,
                    message: <IntlMessages id="global.requiredfield" />,
                  },
                ]}>
                <Select
                  showSearch
                  placeholder="Select type"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }>
                  {Object.entries(rolesTypes).map(([key, value]) => (
                    <Option key={value}>{key}</Option>
                  ))}
                  ;
                </Select>
              </Form.Item>
            )}

            {currentData &&
              ['operator_user', 'collaborator'].some((role) =>
                currentData.roles.includes(role)
              ) && (
                <Form.Item
                  label={<IntlMessages id="global.operator" />}
                  name="operator_id"
                  rules={[
                    {
                      required: true,
                      message: <IntlMessages id="global.requiredfield" />,
                    },
                  ]}>
                  <Select options={operatorOption} />
                </Form.Item>
              )}
            <Form.Item
              label={<IntlMessages id="global.email" />}
              name="email"
              rules={[
                {
                  required: isAdmin ? true : false,
                  message: <IntlMessages id="global.requiredfield" />,
                },
              ]}>
              <Input />
            </Form.Item>

            <Form.Item
              label={<IntlMessages id="global.phone" />}
              rules={[
                {
                  required: true,
                  message: <IntlMessages id="global.requiredfield" />,
                },
              ]}>
              <Input.Group>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      name="phone_code"
                      rules={[
                        {
                          required: true,
                          message: <IntlMessages id="global.requiredfield" />,
                        },
                      ]}>
                      <Select
                        style={{ width: '100%' }}
                        allowClear
                        showSearch
                        placeholder="Select type"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }>
                        {CountryData.map((item, index) => {
                          let labelstr = '';
                          labelstr = `(+${item.code}) ${item.country}`;
                          return (
                            <Option key={index} value={`+${item.code}`}>
                              {labelstr}
                            </Option>
                          );
                        })}
                        ;
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={16}>
                    <Form.Item
                      name="mobile"
                      rules={[
                        {
                          required: true,
                          message: <IntlMessages id="global.requiredfield" />,
                        },
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Input.Group>
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="global.is_verified_email" />}
              name="is_verified">
              <Radio.Group>
                <Radio value={0}>
                  <IntlMessages id="global.unverified" />
                </Radio>
                <Radio value={1}>
                  <IntlMessages id="global.verified" />
                </Radio>
              </Radio.Group>
            </Form.Item>

            {/* <Form.Item
              label={<IntlMessages id="global.image" />}
              name="image"

            >
              <UploadImage onChangeData={onChangeImage} initList={fileList} />
            </Form.Item> */}

            <Form.Item
              label={<IntlMessages id="global.is_mobile_verified" />}
              name="is_mobile_verified">
              <Radio.Group>
                <Radio value={0}>
                  <IntlMessages id="global.unverified" />
                </Radio>
                <Radio value={1}>
                  <IntlMessages id="global.verified" />
                </Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name="status"
              label={<IntlMessages id="global.status" />}>
              <Radio.Group>
                <Radio value={0}>
                  <IntlMessages id="global.inactive" />
                </Radio>
                <Radio value={1}>
                  <IntlMessages id="global.active" />
                </Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label={<IntlMessages id="global.password" />}
              name="password">
              <Input.Password placeholder={place_pass} />
            </Form.Item>
          </TabPane>
        </Tabs>
      </Form>
    </Modal>
  );
}
